import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { first, map } from 'rxjs/operators';
import { UrlBuilder } from '../core';
import { UserStorage } from './user-storage';
import { AudienceRoleName } from '../authentication/audience-role';

const audienceRoleDataKey = 'audienceRole';

@Injectable()
export class UserAudienceRoleGuard implements CanActivate {
    constructor(private userStorage: UserStorage, private urlBuilder: UrlBuilder) {
    }

    public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const audienceRoleName = route.data[audienceRoleDataKey] as AudienceRoleName;

        if (!audienceRoleName) {
            throw new Error('Pass audienceRole to the route.data');
        }

        const userRole = await this.userStorage.currentUser
            .pipe(
                map(u => u.metadata.audienceRole),
                first())
            .toPromise();

        if (!this.isAudienceRoleValid(userRole, audienceRoleName)) {
            this.urlBuilder.esa().navigate();
            return false;
        }

        return true;
    }

    private isAudienceRoleValid(userRole: AudienceRoleName, audienceRoleName: AudienceRoleName | AudienceRoleName[]): boolean {
        if (Array.isArray(audienceRoleName)) {
            return audienceRoleName.indexOf(userRole) !== -1;
        } else {
            return audienceRoleName === userRole;
        }
    }
}

export function audienceRole(roleName: AudienceRoleName | AudienceRoleName[]) {
    return { [audienceRoleDataKey]: roleName };
}
